<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Arquivo movimentação de Receituário - CFTA</div>
            <div class="subTitulo">Gere aqui o arquivo de movimentação de Receituário - CFTA</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Data Inicial">
              <date-picker id="input-2" v-model="estoqueRequest.data_inicial" :first-day-of-week="0" format="YYYY-MM-DD"
                value-type="format" lang="pt-br" placeholder="dd/mm/yyyy" :class="{
                  empty: isSubmit && estoqueRequest.data_inicial === '',
                }"></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Data Inicial">
              <date-picker id="input-2" v-model="estoqueRequest.data_final" :first-day-of-week="0" format="YYYY-MM-DD"
                value-type="format" lang="pt-br" placeholder="dd/mm/yyyy" :class="{
                  empty: isSubmit && estoqueRequest.data_final === '',
                }"></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <button class="btn btn-webreceita" @click="getCsv">Gerar</button>
          </div>
        </div>
      </div>
      <loading :active.sync="isLoading" color="#008e75" :can-cancel="true"></loading>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import reports from '@/src/services/reports/reports'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

export default {
  components: { Layout, Loading, DatePicker },
  data() {
    return {
      isLoading: false,
      estoqueRequest: {
        data_inicial: '',
        data_final: '',
      },
      isSubmit: false,
    }
  },
  watch: {
    estoqueRequest: {
      handler: function (val, oldVal) {
        this.isSubmit = false
      },
      deep: true,
    },
  },
  methods: {
    getCsv() {
      if (this.estoqueRequest.art !== '') {
        this.isLoading = true
        const token = this.$store.state.auth.currentUser.token
        reports
          .reportCfta(token, this.estoqueRequest.data_inicial, this.estoqueRequest.data_final)
          .then((response) => {
            const byteCharacters = atob(response.data.base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // Criar URL do objeto para o PDF
            const url = URL.createObjectURL(blob);

            // Criar link para forçar download
            const hiddenElement = document.createElement('a');
            hiddenElement.href = url;
            hiddenElement.download = response.data.fileName || 'relatorio.pdf';
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
            document.body.removeChild(hiddenElement);

            // Revogar URL para liberar memória
            URL.revokeObjectURL(url);

            this.isLoading = false;
          })
          .catch((err) => {
            this.isLoading = false
            this.$bvToast.toast(
              err.response.data.msg || 'Ecorreu um erro ao Criar Arquivo',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
      } else {
        this.isSubmit = true
        this.$bvToast.toast('Preencha os campos de obrigatórios!', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      }
    },
  },
}
</script>

<style>
.empty {
  border: 1px solid red;
}
</style>